window.onload = (event) => {

  function findParentElement(childSelector, parentSelector) {
    let currentElement = childSelector.parentElement;

    while (currentElement !== null) {
      if (currentElement.matches(parentSelector)) {
        return currentElement;
      }
      currentElement = currentElement.parentElement;
    }

    return null;
  }

  function isElementOutOfBounds(element) {
    const parentElement = findParentElement(element, '.dot-block');
    const parentRect = parentElement.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();
    const elementText = element.querySelector('.dot_block__item-text');
    const elementTextRect = elementText.getBoundingClientRect();

    elementText.style.setProperty('--mobLeft', `-${elementRect.left - parentRect.left - 15}px`);
    elementText.style.setProperty('--mobRight', `-${parentRect.right - elementRect.right - 15}px`);

    element.classList.add('scale');

    if ((elementRect.right + 100) > parentRect.right && elementRect.left > parentRect.width / 2) {
      element.classList.add('reverse');
    }

    return false;
  }

  const elements = document.querySelectorAll('.dot_block__item');
  elements.forEach(item => {
    isElementOutOfBounds(item);

    if (window.innerWidth > 1200) {
      item.addEventListener("mouseenter", () => {
        item.classList.add('hover');
      });

      item.addEventListener("mouseleave", () => {
        item.classList.remove('hover');
      });
    } else {
      item.addEventListener("click", () => {
        Array.from(elements).map(elem => {
          if (elem != item) {
            elem.classList.remove('hover');
          }
        })
        setTimeout(() => {
          item.classList.toggle('hover');
        }, 150);
      });
    }

  });



};// load
